import { useNavigate } from "react-router-dom";
import FilterCategoryButton from "./FilterCategoryButton/FilterCategoryButton";
import classes from "./FilterCategoryTab.module.scss";

const FilterCategoryTab = ({
  categories,
  selectedCategory,
  onChangeFilter,
}) => {
  const navigate = useNavigate();
  return (
    <div className={classes.FilterCategoriesTab}>
      <button
        onClick={() => navigate("/orders/categories")}
        className={classes.SeeAll}
      >
        See All
      </button>
      {categories.map((category) => {
        return (
          <FilterCategoryButton
            key={category.name}
            name="filterCategory"
            value={category.name}
            text={category.name}
            isChecked={selectedCategory === category.name}
            onChanged={onChangeFilter}
          />
        );
      })}
    </div>
  );
};

export default FilterCategoryTab;
